import Header from "./Header";
import Footer from "./Footer";
import CustomScripts from "./CustomScripts";
import Seo from "./Seo";
import { SeoProvider } from "./seo/PageSeo";

export default function Layout({ children }) {
  return (
    <SeoProvider>
      <div className="min-h-screen flex flex-col">
        <Seo />
        <Header />
        <main className="flex-1">{children}</main>
        <Footer />
        <CustomScripts />
      </div>
    </SeoProvider>
  );
}
